import React from 'react';
import './Faculties.css';
import { Card } from 'react-bootstrap';
import ArtCourseImg from '../../utils/images/art-course.jpg';
import BusinessCourseImg from '../../utils/images/business-course.jpg';
import ComputerScienceCourseImg from '../../utils/images/computer-science-course.jpg';
import EducationCourseImg from '../../utils/images/education-course.jpg';
import HealthcareCourseImg from '../../utils/images/healthcare-course.jpg';
import LawCourseImg from '../../utils/images/law-course.jpg';
import MusicCourseImg from '../../utils/images/music-course.jpg';
import SportCourseImg from '../../utils/images/sport-course.jpg';
import FaqAccordion from '../../components/FaqAccordion/FaqAccordion';

const faculties = [
    {
        id: 1,
        img: [ArtCourseImg],
        title: 'Scholarships',
        description: 'This office has carried out all the activities of Students relating to Financial Assistance / Scholarship matters as well as dealing with the Philanthropist and Donor Agencies. Furthermore, this office also awarded the Prime Minister’s as per approved criteria set by the Higher Education Commission Islamabad, on the directions of Prime Minister Republic of Pakistan. The total number of 2548 Laptops awarded amongst the eligible students in  Phase-i-ii-iii-IV & V from fiscal year 2015 to 2019.'
    },
    {
        id: 2,
        img: [BusinessCourseImg],
        title: 'Hostel & Residences',
        description: 'In QUEST, Nawabshah, there are 10 Boys/Girls Hostels in the Campus; 07 for Boys and 03 for Girls. Each Boys Hostel has the capacity of 180 students for accommodation and 108 for Girls students. All the Hostels are located at a walking distance from the Academic Blocks of the University'
    },
    {
        id: 3,
        img: [ComputerScienceCourseImg],
        title: 'IT Services',
        description: 'IT Services section was established to provide voice, data, web, videoconference, hardware & software support, network related services and to facilitate inter departmental communication. It also connects QUEST Intranet to the outside world through a bandwidth of 235 Mbps on fiber link.'
    },
    {
        id: 4,
        img: [EducationCourseImg],
        title: 'Language Course ',
        description: 'The English Language Centre of the University is located at the 1st floor of Central Library Building. The Center offers English, Communication Skills, Research Methodology, and Academic Writing Skills courses currently. The Centre is well equipped with men and material in terms of PhD qualified faculty and state of the art audio and video Laboratories.'
    },
    {
        id: 5,
        img: [HealthcareCourseImg],
        title: 'Medical Facilities ',
        description: 'A dispensary has been established in the hostel premises for the resident students, sufficient quantity of essential medicines are available in the dispensary for minor ailments. A qualified senior doctor has been appointed for the dispensary at Boys Residence Hostel and a qualified senior female doctor also has been appointed for Girls Residence Hostel. However, serious cases are referred to proper hospitals.'
    },
    {
        id: 6,
        img: [LawCourseImg],
        title: 'Transport Facilities',
        description: 'The buses ply between the city centre, the hostels and the academic blocks for the commutation of both the staff as well as students. University buses ply between hostels, city center and campus during office hours and between hostels and city center during evening time. Transport is being looked after by a Senior Teacher as a Chairman Transport. '
    },
    {
        id: 7,
        img: [MusicCourseImg],
        title: 'Central Library QUEST Nawabshah',
        description: 'The Central Library started the functioning in new state of the art building located near Multipurpose Hall since December 2018. The New building provides the congenial and cool atmosphere to students for the reading. New Air Conditioners are installed to provide the cooling facility.'
    },
    {
        id: 8,
        img: [SportCourseImg],
        title: 'Sports Facilities',
        description: 'Quaid-e-Awam University provides excellent sports facilities to its students because it is believed that a healthy mind requires a healthy body'
    },
];

function Faculties() {
  return (
    <div className='faculties-page'>
        <header className='height-60'>
            <div className='container h-100 d-flex flex-column align-items-center justify-content-center text-light'>
            <h1 className='text-center fw-semibold' style={{ color: 'red' }}>Our facilities</h1>

                <p className='text-center w-75 mb-5'>Quaid-e-Awam University offers state-of-the-art facilities to support academic excellence and personal growth. From modern classrooms and well-equipped labs to a comprehensive library and high-speed internet, students have access to resources that enhance learning. The campus also features recreational spaces, sports facilities, and student activity centers, providing a well-rounded environment for success.</p>
            </div>
        </header>

        <div className='container py-5'>
            <div className='row g-4'>
                {faculties.map((course) => (
                    <div key={course.id} className='col-lg-6'>
                        <Card className='text-white shadow scale-hover-effect'>
                            <Card.Img src={course.img} />
                            <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center p-md-5'>
                                <Card.Title className='fs-1 text-danger'>{course.title}</Card.Title>
                                <Card.Text className='text-center'>{course.description}</Card.Text>
                            </Card.ImgOverlay>
                        </Card>
                    </div>
                ))}
            </div>
        </div>

        <div className='bg-dark text-light py-5'>
            <FaqAccordion />
        </div>
    </div>
  )
}

export default Faculties;